export enum CreditCheckType {
  full = 'FULL',
  simple = 'SIMPLE',
}

export interface CreditCheckAddress {
  street: string;
  zip: string;
  city: string;
  country?: string;
}

export interface CreditCheckPersonalData {
  gender: 'M' | 'F' | 'U';
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  currentAddress: CreditCheckAddress;
}

export interface CreditCheckCompanyData {
  companyType: string | undefined;
  companyName: string;
  crefoIdentificationNumber: string;
  currentAddress: CreditCheckAddress;
  companyLegalForm: string | undefined;
  companyRegisterType: string;
  companyRegisterId: string;
  companyVATId: string;
}

export interface CreditCheckObj {
  personalData: CreditCheckPersonalData[];
  companyData: CreditCheckCompanyData;
  accounts?: { accountId: string }[];
}
